

// js call method
function limit_file_size_for_file_input(TgtDomId, sizeLimit, sizeLimitString){
    const fileInput = document.getElementById(TgtDomId); // input要素
    const handleFileSelect = () => {
        const files = fileInput.files;
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > sizeLimit) {
                const limit_s = 'ファイルサイズは' + sizeLimitString + 'までの制限あるため、容量を圧縮するか、他ファイルを選択ください。';
                alert(limit_s); // エラーメッセージ表示
                fileInput.value = '';
                return;
            }
        }
    }
    fileInput.addEventListener('change', handleFileSelect);
}

// ここが有効になればグローバルに使えるようになる。
window.sn_limit_file_size_for_file_input = limit_file_size_for_file_input;
